export const termosDeUso = 'https://ajuda.olx.com.br/s/article/termos-e-condicoes-de-uso'
export const politicaDePrivacidade = 'https://ajuda.olx.com.br/s/article/politica-de-privacidade'
export const esqueciMinhaSenha = '/recuperacao-senha'
export const faleConosco = 'https://ajuda.olx.com.br/fale-conosco'
export const home = 'https://www.olx.com.br/'
export const busca = 'https://www.olx.com.br/brasil'
export const ajuda = 'https://www.olx.com.br/faq.htm'
export const meusAnuncions = 'https://www3.olx.com.br/account/userads'
export const lojas = 'https://www.olx.com.br/lojas'
export const minhaConta = 'https://www3.olx.com.br/account/form_userinfo'
export const chat = 'https://www3.olx.com.br/password_page/load_page/0?type=CHAT'
export const login = 'https://www3.olx.com.br/account/form_login'
export const dicasDeSeguranca = 'https://www.olx.com.br/security_tips.htm'
export const sobreOlx = 'https://portalolx.olx.com.br/quem-somos/'
export const copyRight = 'https://www.olx.com.br/copyright.htm'
export const storia = 'https://www.storiaimoveis.com.br'
export const inserirAnuncio = 'https://www2.olx.com.br/ai'
export const deactivateAccount = 'https://conta.olx.com.br/desativacao-conta'
export const confirmarTelefone = '/confirmacao-telefone/'
export const alterarTelefone = '/alterar/confirmacao-telefone/'
export const trocaSenha = '/nova-senha'
export const enviarUmaSolicitacao = 'https://ajuda.olx.com.br/fale-conosco'
export const cadastroLink = '/cadastro'
export const reativarConta = 'https://ajuda.olx.com.br/s/article/reativar-conta-na-olx'
export const accountReactivationLink = '/reativacao-conta'
export const emailChangeLink = '/alteracao-email'
export const emailChangeConfirmationLink = '/confirmar-alteracao-email'
export const security =
  'https://dicas.olx.com.br/categoria/seguranca/?ic=prod-mkt&local=banner&campaign=dicas.seguranca&message=conta_seguranca'
export const changePassword = 'https://conta.olx.com.br/nova-senha'
export const deleteAccount = 'https://conta.olx.com.br/exclusao-conta'
export const downloadAccountData = 'https://conta.olx.com.br/download-dados'
export const myAccount = 'https://conta.olx.com.br/meu-cadastro'
export const walletLink = 'https://wallet.olx.com.br/'
export const verifyAccountLink = 'https://verifique-sua-conta.olx.com.br/'
export const secretWordLink = 'https://pt.research.net/r/alterarpalavrasecreta'
export const accountDomain = 'https://conta.olx.com.br'
